// React
import React, { useState, useEffect } from 'react';

// Libs
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

// Assets
import Images from '../../../assets/img';

// Css
import './CustomDatePicker.scss';

/**
 * CustomDatePicker — a date picker styled to match the Bosch a-text-field design.
 * Uses popup mode with fixed popper strategy to avoid clipping issues.
 *
 * Props:
 *  label      - field label text
 *  value      - current value as 'DD/MM/YYYY' string (or empty)
 *  onChange   - callback({ value: 'DD/MM/YYYY' })
 *  required   - boolean — shows * and validates
 */
function CustomDatePicker({
  label,
  value,
  onChange,
  required,
  minDate,
  maxDate,
  disabled
}) {
  const parseDate = (val) => {
    if (!val) return null;
    const m = moment(val, 'DD/MM/YYYY', true);
    return m.isValid() ? m.toDate() : null;
  };

  const [selected, setSelected] = useState(() => parseDate(value));

  useEffect(() => {
    setSelected(parseDate(value));
  }, [value]);

  const handleChange = (date) => {
    setSelected(date);
    onChange?.({ value: date ? moment(date).format('DD/MM/YYYY') : '' });
  };

  const getDisplayValue = () => {
    if (selected) return moment(selected).format('DD/MM/YYYY');
    return value || '';
  };

  return (
    <div
      className={`custom-date-picker a-text-field${disabled ? ' custom-date-picker--disabled' : ''}`}
    >
      <label className='custom-date-picker__label'>
        {label}
        {required && <span className='dropdown_single__required'> *</span>}
      </label>

      {/* ReactDatePicker */}
      <ReactDatePicker
        selected={selected}
        onChange={handleChange}
        dateFormat='dd/MM/yyyy'
        placeholderText='DD/MM/YYYY'
        popperPlacement='bottom-start'
        popperProps={{ strategy: 'fixed' }}
        wrapperClassName='custom-date-picker__wrapper'
        className='custom-date-picker__input'
        autoComplete='off'
        value={getDisplayValue()}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />

      <img
        src={Images.calenderIcon}
        alt='calendar-icon'
        className='custom-date-picker__icon'
      />
    </div>
  );
}

export default CustomDatePicker;
